// T-203 — vue « À faire » : les actions à échéance, par période (en retard, aujourd'hui, cette semaine). Chaque commercial voit les siennes ;
// un gestionnaire peut basculer sur toute l'équipe. Un clic ouvre la fiche existante (prospect ou client). Aucune grille de dossiers.
import { useCallback, useEffect, useState } from "react";
import { enteteTenant } from "../../../utils/enteteTenant";
import { formatEcheance, estEnRetard, aujourdhuiIso } from "../../../components/crm/SuiviActions";
import { useConfigList } from "../../../hooks/useConfigList";

const API = process.env.REACT_APP_BACKEND_URL;
export const EVENEMENT_OUVRIR_CIBLE = "oh:ouvrir-cible";
const ONGLETS = [["retard", "En retard"], ["aujourdhui", "Aujourd'hui"], ["semaine", "Cette semaine"]];
const ROLES_GESTIONNAIRES = ["admin", "manager", "super_admin"];

export default function AFaire({ tenantId }) {
  const role = (() => { try { return (JSON.parse(localStorage.getItem("user") || "{}") || {}).role; } catch { return null; } })();
  const estGestionnaire = ROLES_GESTIONNAIRES.includes(role);
  const { items: types } = useConfigList("crm_types_action");
  const [periode, setPeriode] = useState("aujourdhui");
  const [qui, setQui] = useState("moi");
  const [data, setData] = useState({ actions: [], compteurs: { retard: 0, aujourdhui: 0, semaine: 0 } });
  const [erreur, setErreur] = useState(null);

  const charger = useCallback(async () => {
    const tok = localStorage.getItem("session_token");
    try {
      const r = await fetch(`${API}/api/crm/actions/a-faire?periode=${periode}&qui=${qui}`, {
        credentials: "include", headers: { ...enteteTenant(tenantId), ...(tok ? { Authorization: `Bearer ${tok}` } : {}) } });
      if (r.ok) { setData(await r.json()); setErreur(null); }
      else setErreur(r.status === 403 ? "Le suivi des actions n'est pas activé pour cet espace ou pour votre rôle." : "Chargement impossible");
    } catch { setErreur("Erreur réseau"); }
  }, [periode, qui, tenantId]);
  useEffect(() => { charger(); }, [charger]);

  const libelleType = (id) => (types || []).find((t) => t.id === id)?.label || id;
  const ouvrir = (a) => window.dispatchEvent(new CustomEvent(EVENEMENT_OUVRIR_CIBLE, { detail: a.cible }));

  return (
    <div className="space-y-4" data-testid="a-faire">
      <div className="flex items-center gap-3 flex-wrap">
        <h2 className="text-lg font-medium" style={{ color: "var(--oh-text)" }}>À faire</h2>
        {estGestionnaire && (
          <div className="ml-auto flex gap-1" role="group" aria-label="Périmètre">
            {[["moi", "Mes actions"], ["tous", "Toute l'équipe"]].map(([v, l]) => (
              <button key={v} type="button" onClick={() => setQui(v)} data-testid={`a-faire-qui-${v}`} aria-pressed={qui === v} className="text-sm px-3 py-1.5 rounded-lg border"
                style={qui === v ? { background: "var(--oh-accent-bg)", color: "var(--oh-accent-text)", borderColor: "var(--oh-accent)" } : { background: "var(--oh-bg-surface)", color: "var(--oh-text)", borderColor: "var(--oh-border)" }}>{l}</button>
            ))}
          </div>
        )}
      </div>
      <div className="flex gap-2 flex-wrap" role="tablist" aria-label="Période">
        {ONGLETS.map(([k, l]) => (
          <button key={k} type="button" role="tab" aria-selected={periode === k} onClick={() => setPeriode(k)} data-testid={`a-faire-onglet-${k}`} className="text-sm px-3 py-1.5 rounded-lg border"
            style={periode === k ? { background: "var(--oh-accent-bg)", color: "var(--oh-accent-text)", borderColor: "var(--oh-accent)" } : { background: "var(--oh-bg-surface)", color: "var(--oh-text)", borderColor: "var(--oh-border)" }}>
            {l} <span data-testid={`a-faire-compteur-${k}`}>({data.compteurs?.[k] ?? 0})</span>
          </button>
        ))}
      </div>
      {erreur && <p className="text-sm" role="alert" style={{ color: "var(--oh-error-text)" }}>{erreur}</p>}
      {!erreur && data.actions.length === 0 && <p className="text-sm" data-testid="a-faire-vide" style={{ color: "var(--oh-text-muted)" }}>Rien à faire sur cette période.</p>}
      <ul className="space-y-2">
        {data.actions.map((a) => (
          <li key={a.id}>
            <button type="button" onClick={() => ouvrir(a)} data-testid="a-faire-ligne" className="w-full text-left rounded-lg px-3 py-2"
              style={{ background: "var(--oh-bg-elevated)", border: "0.5px solid var(--oh-border)", cursor: "pointer" }}>
              <div className="flex items-center gap-2 flex-wrap text-xs" style={{ color: "var(--oh-text-muted)" }}>
                <span className="font-medium" style={{ color: estEnRetard(a, aujourdhuiIso()) ? "var(--oh-error-text)" : "var(--oh-text)" }}>{libelleType(a.type_action)} · {formatEcheance(a)}</span>
                <span>{a.cible?.type === "client" ? "Client" : "Prospect"} : {a.cible_libelle}</span>
                {qui === "tous" && <span className="ml-auto">Assignée à {a.assigne_libelle}</span>}
              </div>
              {a.texte && <p className="text-sm mt-1" style={{ color: "var(--oh-text)" }}>{a.texte}</p>}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
